var _polygon, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Normal",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "716.051px",
    height: "716.049px",
    viewBox: "0 0 716.051 716.049",
    enableBackground: "new 0 0 716.051 716.049",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#00B25A",
    points: "0,358.023 358.022,716.049 716.051,358.023 358.022,0 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M224.25,247.797c3.698,13.774,13.474,23.117,21.837,20.874l163.479-43.877 c5.135-1.377,8.539-6.809,9.547-13.982l0.006,0.017c0.539-3.654,3.188-6.819,6.982-7.839l34.625-9.293 c3.854-1.034,5.928-5.783,4.631-10.608c-1.293-4.826-5.469-7.897-9.324-6.864l-34.619,9.292c-3.828,1.027-7.734-0.417-10.027-3.357 l0.004,0.009c-4.459-5.654-10.098-8.618-15.213-7.248l-163.475,43.877C224.338,221.042,220.555,234.026,224.25,247.797z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M367.061,606.576c4.31-3.066,7.408-5.844,9.295-8.33c2.873-3.742,4.311-5.402,4.311-12.85 c0-6.289-2.037-11.342-6.11-15.162c-4.072-3.818-9.552-5.729-16.439-5.729c-13.14,0-21.201,13.736-21.201,27.121h14.891 c0-6.494,0.512-12.961,6.939-12.961c2.828,0,6.188,2.607,6.188,6.299c0,6.49-4.604,10.824-10.49,15.063 c-6.786,4.873-13.391,12.826-15.227,17.17c-1.914,3.867-2.93,8.137-3.051,12.809h44.626v-15.779h-22.754 C359.803,611.443,367.061,606.576,367.061,606.576z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M358.014,681.629l317.932-317.904L358.014,45.842L40.106,363.725L358.014,681.629z M358.014,59.982 c6.844,6.832,296.958,296.92,303.79,303.742c-6.832,6.832-296.945,296.932-303.79,303.762 c-6.831-6.83-296.934-296.93-303.765-303.762C61.08,356.902,351.183,66.814,358.014,59.982z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg22);
export default __webpack_public_path__ + "static/media/2.2.fa35bdb448e3042cbbff790da530eba3.svg";
export { ForwardRef as ReactComponent };